module.exports = __webpack_public_path__ + "9bec45cc7d67662c2b2b92089ce965f3.png";